<template>
  <section id="sobre-nosotros" class="py-5 py-md-5 bg-white text-dark">
    <div class="container py-4">
      
      <div class="row mb-5 text-center">
        <div class="col-lg-8 mx-auto">
          <h2 class="display-5 fw-bold section-title-dark animate__fadeInDown">
            Impulsando tu Productividad Digital
          </h2>
          <p class="lead text-secondary animate__fadeInDown animate__delay-0s">
            Desde 2015, somos el motor detrás del rendimiento óptimo de tu tecnología. Conoce nuestra historia de excelencia y compromiso.
          </p>
        </div>
      </div>

      <div class="row align-items-center mb-5 pb-4">
        
        <div class="col-lg-6 text-center mb-4 mb-lg-0 order-lg-2">
          <i class="bi bi-laptop large-icon-primary animate__zoomIn animate__delay-0s"></i>
        </div>
        
        <div class="col-lg-6 order-lg-1">
          <h3 class="fw-bold mb-3 text-primary animate__fadeInLeft animate__delay-1s">
            Técnicos Certificados, Soluciones Garantizadas
          </h3>
          <p class="text-secondary animate__fadeInLeft animate__delay-1s">
            En **Compuservicio**, no solo reparamos, sino que ofrecemos una **consultoría tecnológica integral**. Nuestro equipo está compuesto por profesionales certificados, apasionados por resolver desde el error de software más complejo hasta el fallo de hardware más crítico.
          </p>
          <p class="text-secondary animate__fadeInLeft animate__delay-1s">
            Creemos firmemente en la **ética profesional** y la **transparencia**. Cada diagnóstico incluye un informe detallado y un desglose de costos. Tu satisfacción y la durabilidad de tu equipo son nuestra máxima prioridad.
          </p>
          <a href="#servicios" class="btn btn-outline-primary mt-3 btn-hover-shadow animate__fadeInLeft animate__delay-1s">
            <i class="bi bi-arrow-right-circle me-2"></i> Explorar Servicios
          </a>
        </div>
        
      </div>

      <hr class="my-5 border-primary opacity-25">

      <div class="row text-center mt-5">
        <h3 class="fw-bold mb-5 text-dark animate__fadeInUp">Nuestros Logros Clave</h3>
        
        <div class="col-md-4 mb-4">
          <div class="achievement-card p-4 h-100 animate__fadeInUp animate__delay-2s">
            <i class="bi bi-calendar-check-fill achievement-icon mb-3"></i>
            <h2 class="display-4 fw-bold text-primary">10+</h2>
            <p class="text-muted fw-bold">Años de Trayectoria</p>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="achievement-card p-4 h-100 animate__fadeInUp animate__delay-2s">
            <i class="bi bi-person-check-fill achievement-icon mb-3"></i>
            <h2 class="display-4 fw-bold text-primary">98%</h2>
            <p class="text-muted fw-bold">Clientes Satisfechos</p>
          </div>
        </div>

        <div class="col-md-4 mb-4">
          <div class="achievement-card p-4 h-100 animate__fadeInUp animate__delay-2s">
            <i class="bi bi-tools achievement-icon mb-3"></i>
            <h2 class="display-4 fw-bold text-primary">5k+</h2>
            <p class="text-muted fw-bold">Proyectos Completados</p>
          </div>
        </div>
      </div>
      
      <hr class="my-5 border-primary opacity-25">

      <div class="row mt-5 pt-4 text-center">
          <div class="col-lg-8 mx-auto p-4 rounded-3 border border-primary cta-final-light animate__fadeInUp animate__delay-3s">
            <h3 class="fw-bold mb-3 text-dark">¿Tienes una falla? ¡Obtén tu diagnóstico gratuito!</h3>
            <a 
                href="https://wa.me/584123659519" 
                target="_blank"
                class="btn btn-whatsapp-lg d-inline-flex align-items-center fw-bold shadow-lg"
            >
                <i class="bi bi-whatsapp me-2 fs-5"></i>
                Chatear con un Experto
            </a>
          </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "SobreNosotros",
};
</script>

<style scoped>
/* IMPORTANTE: Requiere Animate.css para las clases 'animate__' */

/* === Colores y Fondos === */
.bg-white {
    background-color: #ffffff !important; 
}
.text-dark {
    color: #212529 !important;
}
.text-secondary {
    color: #5a5f64 !important;
}

/* === Título y Estilo === */
.section-title-dark {
    /* Título oscuro y definido */
    color: #17171a;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

/* === Iconografía y Animación === */

.large-icon-primary {
    font-size: 10rem;
    color: #0d6efd; /* Azul primario intenso */
    opacity: 0.8;
    text-shadow: 0 0 15px rgba(13, 110, 253, 0.5);
    transition: 0.5s;
    /* Animación de entrada: Zoom In */
    animation: animate__zoomIn 0.7s;
}

.large-icon-primary:hover {
    opacity: 1;
    transform: scale(1.05) rotate(2deg);
}

/* === Cards de Logros (Hitos) === */
.achievement-card {
    background-color: #f8f9fa; /* Fondo gris claro */
    border-radius: 15px;
    border: 1px solid rgba(13, 110, 253, 0.15); 
    transition: 0.3s;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.achievement-card:hover {
    transform: translateY(-5px);
    border-color: #0d6efd;
    box-shadow: 0 8px 25px rgba(13, 110, 253, 0.2); /* Sombra azul en hover */
}

.achievement-icon {
    font-size: 3.5rem;
    color: #0d6efd; 
}

/* === Botones === */
.btn-hover-shadow {
    transition: 0.3s;
}
.btn-hover-shadow:hover {
    box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
}

.btn-whatsapp-lg {
    background: #25D366;
    color: white;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 10px;
    transition: 0.3s;
}
.btn-whatsapp-lg:hover {
    background: #1ebe5d;
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 0 15px rgba(37, 211, 102, 1);
}

/* === CTA Final de la Sección === */
.cta-final-light {
    background-color: #e9ecef; /* Gris muy suave para destacar el CTA */
    border: 2px solid #0d6efd;
    transition: 0.5s;
}
.cta-final-light:hover {
    background-color: #dee2e6;
    transform: scale(1.01);
}

/* === Animaciones de Entrada (Retardos Ajustados) === */
.animate__delay-0s { animation-delay: 0.0s; } 
.animate__delay-1s { animation-delay: 0.3s; } 
.animate__delay-2s { 
    animation-delay: 0.6s; /* Retraso para las cards de Hitos */
    animation-duration: 0.7s;
}
.animate__delay-3s { 
    animation-delay: 1.0s; /* Retraso para el CTA final */
    animation-duration: 0.8s;
}

/* === Responsive para Móviles === */
@media (max-width: 767.98px) {
    .large-icon-primary {
        font-size: 6rem;
    }
    .section-title-dark {
        font-size: 2rem;
    }
    .display-4 {
        font-size: 3rem; /* Los números clave se ven bien en móvil */
    }
    .btn-whatsapp-lg {
        width: 100%;
    }
}
</style>